import React, { FC } from 'react';
import Rate from '../../../../../presentational/financeElements/rate/Rate';
import { RateTypes } from '../../../../../../enum/RateTypes';
import useCustomizeCarContext from '../../../../../../hooks/useCustomizeCarContext';

const DepositPercentageContainer: FC = () => {
  const { selectedCar } = useCustomizeCarContext();
  const value = selectedCar?.finance?.simulation?.deposits?.[0].value;

  return <Rate labelId={RateTypes.DEPOSIT_PERCENTAGE} value={`${value}%`} />;
};

export default DepositPercentageContainer;
